var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.9,5.8C10.8,3.7,8.5,2.4,6,2.4S1.2,3.7,0.1,5.8L0,6l0.1,0.2C1.2,8.3,3.5,9.6,6,9.6s4.8-1.3,5.9-3.4L12,6 L11.9,5.8z M6,8.4C4.7,8.4,3.6,7.3,3.6,6S4.7,3.6,6,3.6S8.4,4.7,8.4,6S7.3,8.4,6,8.4z M1.1,6c0.5-0.8,1.3-1.5,2.2-2 C2.9,4.6,2.6,5.3,2.6,6s0.2,1.4,0.6,2C2.4,7.5,1.6,6.8,1.1,6z M8.7,8c0.4-0.6,0.6-1.2,0.6-2S9.1,4.6,8.7,4c0.9,0.5,1.7,1.1,2.2,2 C10.4,6.8,9.6,7.5,8.7,8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.3e23fbdbed3b964f8c1716fb86e9993f.svg";
export { ForwardRef as ReactComponent };